<template>
  <div>
	<h2>Available Plans</h2>

	<div v-if="loading" class="loading">
	  <loading-indicator />
	</div>

	<div v-else class="plans-container">
	  <div v-for="(plan, index) in plans" :key="index" class="plan-block">
		<h3>{{ plan.name }}</h3>

		<div>
		  <label for="payment-method-{{ index }}">Choose Payment Method:</label>
		  <select v-model="selectedPaymentMethods[index]" :id="'payment-method-' + index">
			<option v-for="method in paymentMethods" :key="method.handle" :value="method.id">
			  {{ method.name }}
			</option>
		  </select>
		</div>

		<button @click="subscribe(plan, index)" :disabled="isProcessing">Subscribe</button>
	  </div>
	</div>
  </div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
  props: {
	plans: {
	  type: Array,
	  required: true
	},
	paymentMethods: {
	  type: Array,
	  required: true
	}
  },
  components: {
	LoadingIndicator
  },
  data() {
	return {
	  selectedPaymentMethods: {},
	  isProcessing: false,
	  loading: false,
	};
  },
  computed: {
	csrfName() {
	  return window.csrfTokenName;
	},
	csrfToken() {
	  return window.csrfTokenValue;
	},
	currentUrl() {
	  return window.location.href; // Get current URL for redirection after payment
	},
  },
  methods: {
	async subscribe(plan, index) {
	  const selectedMethodId = this.selectedPaymentMethods[index];

	  if (!selectedMethodId) {
		alert('Please select a payment method.');
		return;
	  }

	  this.isProcessing = true;
	  this.loading = true;

	  try {
		// Step 1: Create the payment source
		const response = await this.createPaymentSource(plan, selectedMethodId);
		if (response.data.success) {
		  // Step 2: Check if a Stripe redirect is needed
		  if (response.data.requiresAction) {
			// Redirect to the Stripe payment portal
			window.location.href = response.data.redirectUrl;
		  } else {
			// Step 3: Subscribe to the plan with the payment source ID if no redirection is needed
			const paymentSourceId = response.data.paymentSourceId;
			console.log(paymentSourceId);
			
			//await this.handleSubscription(plan, paymentSourceId);
		  }
		} else {
		  alert(response.data.error || 'Failed to create payment source.');
		}
	  } catch (error) {
		console.error('Error during payment source creation:', error);
		alert('An error occurred during the subscription process.');
	  } finally {
		this.isProcessing = false;
		this.loading = false;
	  }
	},
	createPaymentSource(plan, gatewayId) {
	  const payload = {
		description: "Stripe",
		gatewayId,  // Use gatewayId instead of gatewayHandle
		returnUrl: this.currentUrl, // Send current URL for redirection after payment
		[this.csrfName]: this.csrfToken, // Include CSRF
	  };

	  // Prepend /actions/ to the action URL
	  return axios.post('/actions/commerce/payment-sources/add', payload)
		.catch(error => {
		  console.error('Error during payment source creation:', error);
		  alert('Failed to create payment source.');
		});
	},
	handleSubscription(plan, paymentSourceId) {
	  const payload = {
		planUid: plan.uid,
		paymentSourceId,
		returnUrl: this.currentUrl, // Send current URL for redirection after payment
		[this.csrfName]: this.csrfToken, // Include CSRF
	  };

	  // Prepend /actions/ to the action URL
	  return axios.post('/actions/commerce/subscriptions/subscribe', payload)
		.then(response => {
		  if (response.data.success) {
			alert('Subscription successful!');
			window.location.reload();
		  } else {
			alert(response.data.error || 'Subscription failed.');
		  }
		})
		.catch(error => {
		  console.error('Error during subscription:', error);
		  alert('An error occurred during the subscription process.');
		});
	}
  }
};
</script>

<style scoped>
.plans-container {
  display: flex;
  flex-wrap: wrap;
}
.plan-block {
  border: 1px solid #ccc;
  padding: 16px;
  margin: 8px;
  width: 30%;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
